import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/utils/common.utils";

interface AuthLayoutProps {
  children?: ReactNode;
  className?: string;
  contentClassName?: string;
}

export default function AuthLayout({ children, className = "", contentClassName = "" }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-linen">
      <div className="grid lg:grid-cols-2 gap-0 min-h-screen">
        <div className="hidden lg:block relative bg-bone overflow-hidden">
          <img src="/auth-photo.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        </div>

        <div className={cn("relative flex items-center justify-center p-8 lg:p-16", className)}>
          <div className={cn("w-full max-w-md", contentClassName)}>
            <Link to="/" className="mb-8 block" data-testid="auth-brand">
              <img src="/logo.svg" alt="Stoop" className="mx-auto h-10 w-auto" />
            </Link>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
